// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"6620ea5c36524dd65ed1","581":"2aa66e5e6b640f0a3d95","625":"fc9037014f80f121bcbe"}[chunkId] + ".chunk.js";
};